<div class="row">
  <div class="col-sm-8">
    <h3 class="dialog-title">
      <fa-icon [icon]="['fas', 'dollar-sign']" ></fa-icon>&nbsp;
      <span>{{ 'profitability_analysis' | translate }}</span>
    </h3>
  </div>
  <div class="col-sm-4">
    <span class="buttons float-right">
      <fieldmagic-primary-button
        (click)="onCancelDialog()"
        variant="error"
        icon="times"
        label="close"
      ></fieldmagic-primary-button>
    </span>
  </div>
</div>

<hr class="separator"/>

<mat-dialog-content>
  <ng-container *ngIf="!isLoading; else loading">
    <div class="row">
      <div class="col-6">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <td colspan="2" class="text-center font-weight-bold table-title">{{ 'labour' | translate }}</td>
            </tr>
            <tr>
              <td class="text-center font-weight-bold table-sub-title font-size-12">{{ 'total_hours_labour' | translate }}</td>
              <td class="text-center font-weight-bold table-sub-title font-size-12">{{ 'total_cost_labour' | translate }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">{{ objProfitabilityCost.labour_actual_duration }} </td>
              <td class="text-center">{{ objProfitabilityCost.labour_actual_cost | currency: {decimal_places: 4} }} </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <td class="text-center font-weight-bold table-title">{{ 'materials_cost' | translate }}</td>
            </tr>
            <tr>
              <td class="text-center font-weight-bold table-sub-title font-size-12">{{ 'total_materials_cost' | translate }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">{{ objProfitabilityCost.materials_actual_cost | currency: {decimal_places: 4} }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <ng-container *ngIf="arJobTypeAnalysis" [ngTemplateOutlet]="jobTypeAnalysis"></ng-container>
    </div>
    <div class="row">
      <ng-container [ngTemplateOutlet]="profitabilityTotal"></ng-container>
    </div>
  </ng-container>

  <ng-template #jobTypeAnalysis>
    <ng-container *ngFor="let job_type_analysis of arJobTypeAnalysis">
      <div class="col-6">
        <table class="table table-bordered table-sm" width="100%">
          <thead>
            <tr>
              <td colspan="3" width="35%" class="text-center font-weight-bold table-title w-28pi">{{ job_type_analysis.text | translate }}</td>
            </tr>
            <tr>
              <td width="30%" class="text-center font-weight-bold table-sub-title font-size-12"></td>
              <td width="35%" class="text-center font-weight-bold table-sub-title font-size-12">{{ 'billable_jobs' | translate }}</td>
              <td width="35%" class="text-center font-weight-bold table-sub-title font-size-12">{{ 'non_billable_jobs' | translate }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td width="30%" class="font-weight-bold table-sub-title font-size-12 w-16pi">{{ 'number_of_jobs' | translate }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.billable.total_job_count }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.non_billable.total_job_count }}</td>
            </tr>
            <tr>
              <td width="30%" class="font-weight-bold table-sub-title font-size-12 w-16pi">{{ 'total_revenue' | translate }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.billable.total_revenue | currency: {decimal_places: 4} }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.non_billable.total_revenue | currency: {decimal_places: 4} }}</td>
            </tr>
            <tr>
              <td width="30%" class="font-weight-bold table-sub-title font-size-12 w-16pi">{{ 'total_cost_labour' | translate }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.billable.total_labour_cost | currency: {decimal_places: 4} }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.non_billable.total_labour_cost | currency: {decimal_places: 4} }}</td>
            </tr>
            <tr>
              <td width="30%" class="font-weight-bold table-sub-title font-size-12 w-16pi">{{ 'total_materials_cost' | translate }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.billable.total_material_cost | currency: {decimal_places: 4} }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.non_billable.total_material_cost | currency: {decimal_places: 4} }}</td>
            </tr>
            <tr>
              <td width="30%" class="font-weight-bold table-sub-title font-size-12 w-16pi">{{ 'profit' | translate }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.billable.total_profit | currency: {decimal_places: 4} }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.non_billable.total_profit | currency: {decimal_places: 4} }}</td>
            </tr>
            <tr>
              <td width="30%" class="font-weight-bold table-sub-title font-size-12 w-16pi">{{ 'margin' | translate }}</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.billable.total_margin }}%</td>
              <td width="35%" class="text-center w-28pi">{{ job_type_analysis.non_billable.total_margin }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #profitabilityTotal>
    <div class="col-8"></div>
    <div class="col-4">
      <table class="table table-bordered table-sm mb-0">
        <thead>
          <tr>
            <td colspan="2" class="text-center font-weight-bold table-title">{{ 'totals' | translate }}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="font-weight-bold table-sub-title font-size-12" width="50%">{{ 'service_profitability' | translate }} </td>
            <td class="text-center" width="50%">{{ objProfitabilityTotal.service_profitability | currency: {decimal_places: 4} }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold table-sub-title font-size-12" width="50%">{{ 'minor_works_profitability' | translate }} </td>
            <td class="text-center" width="50%">{{ objProfitabilityTotal.minor_works_profitability | currency: {decimal_places: 4} }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold table-sub-title font-size-12" width="50%">{{ 'revenue' | translate }} </td>
            <td class="text-center" width="50%">{{ objProfitabilityTotal.profitability_revenue | currency: {decimal_places: 4} }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold table-sub-title font-size-12" width="50%">{{ 'cost_field' | translate }} </td>
            <td class="text-center" width="50%">{{ objProfitabilityTotal.profitability_cost | currency: {decimal_places: 4} }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold table-sub-title font-size-12" width="50%">{{ 'profit' | translate }} </td>
            <td class="text-center" width="50%">{{ objProfitabilityTotal.profitability_profit | currency: {decimal_places: 4} }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold table-sub-title font-size-12" width="50%">{{ 'margin' | translate }} </td>
            <td class="text-center" width="50%">{{ objProfitabilityTotal.profitability_margin }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-template>

  <ng-template #loading>
    <div class="text-center">
      <inline-view-loader [isLoading]="isLoading"></inline-view-loader>
    </div>
  </ng-template>
</mat-dialog-content>